var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('profile-container', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('capusta-title', {
          attrs: {
            "title": _vm.$t('account.secure'),
            "icon-outside": ""
          },
          scopedSlots: _vm._u([{
            key: "description",
            fn: function fn() {
              return [_c('div', {
                staticClass: "main-description",
                domProps: {
                  "innerHTML": _vm._s(_vm.$t('additional.login.confirmation'))
                }
              })];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }, {
      key: "content",
      fn: function fn() {
        return _vm._l(_vm.types, function (twoFactor) {
          return _c('div', {
            key: twoFactor.name,
            staticClass: "panel-list"
          }, [_c('toggle-panel', {
            attrs: {
              "title": _vm.$t(twoFactor.name),
              "value": twoFactor.value
            },
            on: {
              "click": function click($event) {
                return _vm.onSwitch(twoFactor);
              }
            }
          }, [_c(_vm.getIconComponent(twoFactor.type), {
            tag: "component",
            attrs: {
              "slot": "icon"
            },
            slot: "icon"
          })], 1)], 1);
        });
      },
      proxy: true
    }, {
      key: "icon",
      fn: function fn() {
        return [_c('background-icon', {
          attrs: {
            "active": !!_vm.currentFactor,
            "icon": "2fa"
          }
        })];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }